/* global ReactOnRails */

import ApplicationController from './application_controller'

class ReactController extends ApplicationController {
  connect () {
    ReactOnRails.reactOnRailsPageLoaded()
  }
}

export default ReactController
